var $ajax = {
	getJson: function(config) {
		if (config.abort) {
			config.abort.abort();
		}
		config.params = config.params || {};
		if (!config.caching) {
			config.params._ = Date.now();
		}
		var request = new XMLHttpRequest();
		request.open('GET', $url.encodeVar(config.params, {
			url: config.url,
			uriEncode: config.uriEncode
		}), true);
		request.timeout = config.timeout || 10000; //ms
		request.onload = function() {
		  if (this.status >= 200 && this.status < 400) {
		    try {
		    	var json = JSON.parse(this.response);
		    	if (config.success) config.success.call(config.scope, json);
			} catch(error) {
		    	if (config.failed) config.failed.call(config.scope, 'jsonParseError');
		    	if (debug) window.console.error(error);
			}
		  } else {
		    if (config.failed) config.failed.call(config.scope, 'jsonStatusError');
		  }
  	      if (config.always) config.always.call(config.scope);
		};
		request.ontimeout = function() {
		    if (config.failed) config.failed.call(config.scope, 'jsonTimeout');			
 	        if (config.always) config.always.call(config.scope);
		};
		request.onerror = function() {
			if (config.failed) config.failed.call(config.scope, 'jsonLoadError');
	        if (config.always) config.always.call(config.scope);
		};
		request.send();
		return request;
	},
	post: function(config) {
		var request = new XMLHttpRequest();
		
		config.params = config.params || {};
		var cacheParam = {};
		if (!config.caching) {
			cacheParam._ = Date.now();
		}
		request.open('POST', $url.encodeVar(cacheParam, {
			url: config.url
		}), true);
		request.timeout = config.timeout || 10000; //ms
		request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

		request.onload = function() {
		  if (this.status >= 200 && this.status < 400) {
			var json;
		    try {
		    	json = JSON.parse(this.response);
		    	if (config.success) config.success.call(config.scope, json);
			} catch(error) {
		    	if (config.failed) config.failed.call(config.scope, 'jsonParseError');
		    	if (debug) window.console.error(error);
			}
		  } else {
		    if (config.failed) config.failed.call(config.scope, 'jsonStatusError');
		  }
  	      if (config.always) config.always.call(config.scope);
		};

		request.send($url.encodeVar(config.params));

	}
};